module.exports = __webpack_public_path__ + "img/video.af7734d7.svg";